import { FC } from 'react';
import { Spin, Button } from 'antd';

type Props = {
  isFullPage?: Boolean,
  message?: string,
  error?: string,
  onRetry?: () => void,
}

const Loader: FC<Props> = ({isFullPage, message, error, onRetry}) => {
  if (error) {
    return (
      <div className={`loader-custom ${isFullPage ? 'loader-custom--fullpage':''}`}>
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <h3>Error de carga</h3>
          <p>{error}</p>
          {onRetry && (
            <Button type="primary" onClick={onRetry}>
              Reintentar
            </Button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={`loader-custom ${isFullPage ? 'loader-custom--fullpage':''}`}>
      <Spin size="large" tip={message || "Cargando..."} />
    </div>
  );
};

Loader.defaultProps = {
  isFullPage: false,
  message: "Cargando...",
}

export default Loader;
